import HTTPClient from './http-client';

const END_POINT = '/alertasnowcastes/56';

const loadStorms = async (limit) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
        `${END_POINT}?n=${limit}`
    );
};

export {
    loadStorms
}